/* created by CoolGuy on 2018/11/25 */
import React from 'react';
import Wrapper from './Wrapper';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import moment from 'moment';
import intl from 'react-intl-universal';

const OneTime = ({ index, posttime, length, access_type }) => {
  const mPostTime = moment(posttime - 0);
  // console.log(mPostTime);
  const hms = mPostTime.format('HH:mm:ss');
  const [h, m, s] = hms.split(':');
  return (
    <div className={'one-time'}>
      <span>{intl.get('Nth send time', { num: index + 1 })}</span>
      <div className="hms">
        <span className="time">{h}</span>:<span className="time">{m}</span>:
        <span className="time">{s}</span>
      </div>
      {access_type === 'limit' && `(${intl.get('Limited Red Packet1')})`}
    </div>
  );
};

@inject('rootStore')
@observer
class ForShow extends React.Component {
  setNotificationBar = () => {
    const { redPackStore } = this.props.rootStore;
    const { list } = this.props;
    const one = list[0];
    redPackStore.setNotificationTime(one.posttime, true);
  };
  // 最近的一次显示ForShow（当前组件）的时间
  setLastForShowTime = () => {
    const { redPackStore } = this.props.rootStore;
    const { currentServerTime } = redPackStore;
    redPackStore.setLocalLastForShowTime(null, currentServerTime);
  };

  @computed get filteredList() {
    const { list } = this.props;
    const { redPackStore } = this.props.rootStore;
    const { currentServerTime } = redPackStore;
    const lastForShowTime = redPackStore.getLocalLastForShowTime(null) || 0;
    // 注意，过滤掉自上次时间以来，和noticestep相关的预告
    return list.filter(one => {
      const { posttype, noticestep } = one;
      // 不阻止弹框
      if (+noticestep === 0) {
        return true;
      }
      // 正常情况下不应该会有这种类型的数据过来
      if (posttype === 'now') {
        console.warn('This should not be possible', one);
        return true;
      }
      // 没有获取过，说明是第一次
      if (!lastForShowTime) {
        return true;
      }
      if (+noticestep < currentServerTime - lastForShowTime) {
        return true;
      }
      return false;
    });
  }

  willShowMain = () => {
    return this.filteredList.length > 0;
  };

  componentDidMount() {
    this.setNotificationBar();
    // 只有ForShow主内容展示的时候才更新这个时间
    this.willShowMain() && this.setLastForShowTime();
    // console.log(this.props.rootStore.redPackStore.currentGalleryId)
  }

  render() {
    const { onClose } = this.props;
    const list = this.filteredList;
    if (!this.willShowMain()) {
      return null;
    }
    return (
      <Wrapper onClose={onClose}>
        <div className="special-bottom">
          <span className={'name'}>{intl.get('Red Pack Advance Notice')}</span>
          <div className="times">
            {list.map((one, index) => (
              <OneTime
                {...one}
                index={index}
                key={one.id}
                length={list.length}
              />
            ))}
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default ForShow;
